import React, { useCallback } from 'react';
import { observer } from 'mobx-react';

import { translate } from 'services/i18nService';
import ModalService from 'services/ModalService';
import ProfileStore from 'stores/ProfileStore';
import Button from 'components/Button/Button';
import ContentCard from 'components/ContentCard/ContentCard';
import { generateID } from 'utils/helpers';

import Award from './Award/Award';
import styles from './ProfileAwards.css';


const IDS = {
  prefix: 'te93st20',
  element: 'profileAwards',
  seeAllAwards: 'seeAllAwards',
};
const makeId = generateID(IDS.prefix, IDS.element);

const ProfileAwards = () => {
  const { defaultAwardsState, awards } = ProfileStore;

  const toggleAllAwards = useCallback(() => {
    ModalService.showModal(ModalService.MODAL_KEYS.ALL_AWARDS, {
      close: ModalService.hideModal,
      show: true,
    });
  }, []);

  return (
    <ContentCard
      className={styles.profileAwards}
      contentClass={styles.defaultContent}
      footer={
        awards.length > 4 ? (
          <Button
            id={makeId(IDS.seeAllAwards)}
            label={translate('v2profile.see.all.awards')}
            onClick={toggleAllAwards}
          />
        ) : undefined
      }
      footerClass={styles.footer}
      title={translate('v2profile.awards')}
    >
      <div className={styles.defaultStateAwardsWrapper}>
        {defaultAwardsState.map((award, key) => (
          <Award key={`award-${key}-${award.awardType}`} allAwards={false} award={award} />
        ))}
      </div>
    </ContentCard>
  );
};

export default observer(ProfileAwards);
